import { defineMessages } from 'react-intl';

export const a2aDetailsMessages = defineMessages({
  detailsTitle: {
    id: 'oauth.a2a.details.title',
    defaultMessage: 'Details',
    description: 'Section heading for A2A app details',
  },
  nameLabel: {
    id: 'oauth.a2a.details.nameLabel',
    defaultMessage: 'Name',
    description: 'Label for the app name detail row',
  },
  domainLabel: {
    id: 'oauth.mcp.details.domainLabel',
    defaultMessage: 'Domains',
    description: 'Label for the Domain URL detail row',
  },
});
